import { AlertCircleIcon } from '@orn/shared-web/icons';

import PlaidLinkButton from '../PlaidLinkButton';

import type { IButtonProps } from '@orn/shared-web/components/Button/Button';

interface IPlaidFixConnectionButtonProps {
  /** The size variant of the button */
  size?: IButtonProps['size'];
  /** The bank connection ID to reconnect */
  bankConnectionId: string;
  /** Optional callback when reconnection succeeds */
  onSuccess?: () => void;
  /** Optional className for additional styling */
  className?: string;
}

const PlaidFixConnectionButton = ({
  size = 'sm',
  bankConnectionId,
  onSuccess,
  className,
}: IPlaidFixConnectionButtonProps) => {
  return (
    <PlaidLinkButton
      bankConnectionId={bankConnectionId}
      onSuccess={onSuccess}
      size={size}
      color="primary-destructive"
      iconLeading={AlertCircleIcon}
      className={className}
    >
      Fix connection
    </PlaidLinkButton>
  );
};

export default PlaidFixConnectionButton;
